import React from 'react';
// import { useRouter } from 'next/router';

import { localeToLang } from 'providers/prismic/utils/localeToLang';
import { getLayout, IPrismicLayout } from 'providers/prismic/layout';
import { getPersonBySlug, IPrismicPerson } from 'providers/prismic/person';
import { Layout } from 'containers/layout/Layout';
import { Header } from 'components/header/Header';
import { SplitPageLayout } from 'components/split-page/SplitPageLayout';
import { Text } from 'components/text/Text';
import { SplitPageSection } from 'components/split-page/SplitPageSection';
import { RichText } from 'components/rich-text/RichText';
import { createSlug } from 'providers/prismic/utils/createSlug';
import { config } from 'utils/config';
import { PeopleInfo } from 'components/people/PeopleInfo';

type Props = {
  preview: boolean;
  layout: IPrismicLayout;
  person: IPrismicPerson;
  url: string | null;
};

export default function PersonPage({ preview, layout, person, url }: Props) {
  // const router = useRouter();

  // const handleClose = () => {
  //   router.back();
  // };

  // const checkSameDomainReferer = () => {
  //   if (process.browser) {
  //     if (document.referrer.indexOf(window.location.protocol + '//' + window.location.host) === 0) {
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  // const referrerSameDomain = checkSameDomainReferer();

  return (
    <Layout
      layout={layout}
      seo={{
        title: person.seo?.title || person.name,
        description: person.seo?.description || RichText.asText(person.bio),
        image: person.seo?.image || person.image,
        canonicalUrl: url,
      }}
      header={<Header color="brand" fixed />}
      preview={preview}
    >
      <SplitPageLayout
        imagePosition="top"
        // onClose={referrerSameDomain ? handleClose : undefined}
      >
        <SplitPageSection image={person.image}>
          <Text
            isSlice
            isSplitPage
            tagline={person.position}
            title={person.name}
            text={RichText.render(person.bio)}
            titleTag="h1"
          />
          <PeopleInfo
            email={person.email}
            phonenumber={person.phonenumber}
            linkedin={person.linkedin}
          />
        </SplitPageSection>
      </SplitPageLayout>
    </Layout>
  );
}

export async function getStaticProps({ params, preview = false, previewData, locale }) {
  const lang = localeToLang(locale);

  const layout = await getLayout({ previewData, lang });
  const person = await getPersonBySlug(params.person, {
    previewData,
    lang,
    redirects: layout?.redirects,
  });

  if (person?.altLink?.href) {
    return {
      redirect: {
        destination: person.altLink.href,
        permanent: true,
      },
    };
  }

  const url = createSlug({
    includeSiteUrl: true,
    lang: lang,
    prefix: 'team',
    uid: person?.uid,
    layouts: [layout],
  });

  return {
    notFound: !person,
    props: {
      preview,
      layout,
      person,
      url,
    },
    revalidate: config.revalidate,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
